import React from 'react';
import { Layer, Stage, Image, Rect } from 'react-konva';
import { StepsIntl } from './Steps.intl';
import './Steps.scss';
import { useIntl } from 'react-intl';
import { useField } from 'formik';
import { useQueryClient } from 'react-query';
import { QueryKey, useRedLinePosition, useSelectedImage, steps } from '../helper';
import { CONTAINER_HEIGHT, CONTAINER_WIDTH, initial } from '../models';
import { useBem } from '../../Bem';

export const Step5 = () => {
  const queryClient = useQueryClient();
  const bem = useBem('step5');
  const intl = useIntl();
  const [lowestUsableRow, lowestUsableRowMeta, lowestUsableRowHelpers] = useField({ name: 'lowestUsableRow' });
  const selectedImage = useSelectedImage();
  const { redLinePosition } = useRedLinePosition();

  const getY = (maxHeight: number, minHeight: number, pos: number) => {
    if (pos >= maxHeight) {
      return maxHeight - 1;
    }
    if (pos <= minHeight) {
      return minHeight;
    }
    return pos;
  };

  return (
    <div>
      <p className={bem.elem('title').cls()}>
        <span>(5/{steps.length})&nbsp;</span>
        <span>{intl.formatMessage(StepsIntl.titleStep_5)}</span>
      </p>
      <div className={bem.elem('canvas_margin').cls()}>
        <Stage className={bem.elem('canvas').cls()} width={CONTAINER_WIDTH} height={CONTAINER_HEIGHT}>
          <Layer>
            <Image image={selectedImage} x={0} y={0} />
            <Rect
              x={0}
              y={redLinePosition}
              height={1}
              width={614}
              stroke="#e74a4a"
              strokeWidth={3}
              draggable
              onDragEnd={(e) => {
                queryClient.setQueryData(QueryKey.redLinePosition, getY(CONTAINER_HEIGHT, 50, e.target.y()));
                lowestUsableRowHelpers.setValue(getY(CONTAINER_HEIGHT, 50, e.target.y()));
              }}
              onMouseEnter={(e: any) => {
                const container = e.target.getStage().container();
                container.style.cursor = 'row-resize';
              }}
              onMouseLeave={(e: any) => {
                const container = e.target.getStage().container();
                container.style.cursor = 'default';
              }}
              dragBoundFunc={(pos) => {
                pos.x = 0;
                pos.y = getY(CONTAINER_HEIGHT, 50, pos.y);
                return pos;
              }}
            />
          </Layer>
        </Stage>
      </div>
    </div>
  );
};
